export const load = () => ({
	h1: 'Work Comfortably with Soundproofing Window Inserts for your Office',
	title: 'Soundproof your Office with Interior Storm Window Inserts',
	description:
		'Block out the noise and concentrate better with office soundproofing. Window inserts reduce noise by up to 70%, make the office more comfortable by blocking drafts, and are easy to install.',
	showTitle: true,
});
